import { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { parentInactiveReasons } from '@/stores/data';
import Select from '@/components/select';

const InactiveModal = ({ open, loading, onSave, onClose }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    await onSave(
      values.reason === parentInactiveReasons[parentInactiveReasons.length - 1].id
        ? `Other: ${values.other}`
        : values.reason,
    );
    onClose();
  };

  return (
    <Modal
      title="Change to inactive"
      open={open}
      okText="Save"
      confirmLoading={loading}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
          <Select
            options={parentInactiveReasons}
            onChange={() => {
              form.setFieldValue('other', undefined);
            }}
          />
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.reason !== currentValues.reason}>
          {({ getFieldValue }) => {
            return (
              getFieldValue('reason') === parentInactiveReasons[parentInactiveReasons.length - 1].id && (
                <Form.Item name="other">
                  <Input.TextArea autoSize={{ minRows: 2 }} />
                </Form.Item>
              )
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InactiveModal;
